<template>
  <div class="hosphome">
    <div class="hosphome-background">
      <div class="hosphome-AppTitle">
        <img src="../../public/obraoag/NewCapeReturn.png" alt="" @click="BackLevel()">
        欧堡利亚医院
      </div>
      <router-link :to="{path: 'hospital'}">
        <div class="hosphome-rotaon">
          <img src="../../public/obraoag/rotain.png" alt="">
        </div>
      </router-link>
      <div class="hosphome-astion">
        <div class="hosphome-astion-left">
          <img src="../../public/obraoag/purcse.png" alt="">
        </div>
        <div class="hosphome-astion-right">
          <div class="hosphome-astion-right-makent">
            <router-link :to="{path: 'phyexcon'}">
              <img src="../../public/obraoag/makeap.png" alt="">
            </router-link>
          </div>
          <div class="hosphome-astion-right-makent">
            <router-link :to="{path: 'repore'}">
              <img src="../../public/obraoag/repoat.png" alt="">
            </router-link>
          </div>
        </div>
      </div>
      <div class="hosphome-chacst">
        <img src="../../public/obraoag/projct.png" alt="">
      </div>
      <div class="hosphome-spcial">
        <img src="../../public/obraoag/specal.png" alt="">
      </div>
      <div class="hosphome-rement">
        <img src="../../public/obraoag/recomd.png" alt="">
      </div>
      <div class="hosphome-contac">
        <img src="../../public/obraoag/conact.png" alt="">
      </div>
    </div>
    <!-- 预约成功提示 -->
    <div class="js_dialog" id="iosDialog2" :style="'display:' + hoatps">
      <div class="weui-mask"></div>
      <div class="weui-dialog">
        <div class="weui-dialog__bd">恭喜您,预约成功!</div>
        <div class="weui-dialog__bd">请于<span class="hospital-prmtor">{{this.hosume}}</span>前往盐城市盐南高新区人民南路38号新龙广场15号楼(海洋路与戴庄路交汇处)欧堡利亚医院进行体检，过时所产生的购买费用不予退还，需要重新预约时间即可。</div>
        <div class="weui-dialog__bd">我们已将体检信息短信发至：{{this.homoes}}请注意查收！</div>
        <div class="weui-dialog__bd">欧堡利亚医院期待您的光临！</div>
        <div class="weui-dialog__ft">
          <a href="javascript:" class="weui-dialog__btn weui-dialog__btn_primary" style="color: #DA2819;" @click="hoclpt()">知道了</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "./obraojs/rem"
export default {
  data () {
    return{
      hoatps: 'none',
      hoanus: '',
      hosume: '',
      homoes: ''
    }
  },
  created () {
    // 从缓存里获取预约成功的提示状态
    this.hoanus = localStorage.getItem("tianus");
    // 接收填写时间段传过来的信息
    this.hosume = this.$route.query.tisume;
    this.homoes = this.$route.query.timoes;
    if(this.hoanus == '1'){
      this.hoatps = 'block';
    }
  },
  mounted () {

  },
  methods: {
    // 点击知道了触发
    hoclpt(){
      this.hoatps = 'none';
      localStorage.removeItem("tianus");
    },
    // 返回上一层
    BackLevel(){
      this.$router.push({name: 'HomePage'});
    }
  }
}
</script>

<style scoped>
  @import "obraocs/hosphome.css";
</style>